/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum TokenPolicyEffect {
  Allow = "Allow",
}

export const TokenPolicyEffectDisplay: Record<TokenPolicyEffect, string> = {
  [TokenPolicyEffect.Allow]: "Allow",
};
